import { INCIDENTS_SET, INCIDENT_ADDED, RESOURCE_ADDED, RESOURCE_SET } from 'src/app/redux/redux-types';
import { reduxResourceTypes } from 'src/types';

export const resourceDefaultState: reduxResourceTypes.StateType = {
  resourceList: [],
};

export const resourceReducer = (
  state = resourceDefaultState,
  action: reduxResourceTypes.ActionType,
): reduxResourceTypes.StateType => {
  switch (action.type) {
    case RESOURCE_SET:
      return {
        ...state,
        resourceList: action.payload,
      };
    case RESOURCE_ADDED:
      state.resourceList.push(action.payload);
      return {
        ...state,
      };
    default:
      return state;
  }
};
